import { Box, Button, Modal, Paper, Typography } from "@mui/material";
import colors from "../theme/colors";
import { PLAYER } from "../types/players";

interface UndoModalProps {
  open: boolean;
  undo: Function;
  cancel: Function;
  requestedPlayer?: PLAYER;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: 400,
  bgcolor: colors.mediumGreen,
  boxShadow: 24,
  p: 4,
};

export default function UndoModal({
  open,
  undo,
  cancel,
  requestedPlayer,
}: UndoModalProps) {
  return requestedPlayer ? (
    <Modal open={open}>
      <Paper elevation={6}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" align="center">
            {requestedPlayer} has requested an undo to their last throw
          </Typography>
          <Box display={"flex"} justifyContent={"space-around"}>
            <Button
              variant="contained"
              style={{ backgroundColor: "#1B4F2D" }}
              onClick={() => undo()}
            >
              Undo
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#881918" }}
              onClick={() => cancel()}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Paper>
    </Modal>
  ) : null;
}
